import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {CountryService} from "app/services";
import {fetchAllCountries} from "./countires-list.slice";
import {errorMsg, successMsg} from "../../../../utils/MessageUtils";
import {CountryRequestBody} from "../../../../types/service-types/CountryTypes";

interface UpdateCountryStateParams {
  id: string;
  body: CountryRequestBody;
  onSuccess?: Function;
  onError?: Function;
}

export const updateCountry = (params: UpdateCountryStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await CountryService.updateCountry(params.id, params.body);
    console.log(response);
    if (response.status >= 200 || response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Country changed successfully!' : 'Shteti u ndryshua me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllCountries());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface UpdateCountrySlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdateCountrySlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'configurations/countries',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;